import React, { useState, useMemo, useContext } from "react";
import { CameraIcon, MenuAlt1Icon, RefreshIcon, LightningBoltIcon, IdentificationIcon } from "@heroicons/react/solid"

import DrawFreedraw from "../images/draw_Freedraw.svg";
import DrawFreedrawSele from "../images/draw_Freedraw_sele.svg";
import AiSele from "../images/ai_sele.svg";
import Ai from "../images/ai.svg"
import { viewImgContext } from "..";

const className = "w-10 cursor-pointer flex item-center m-auto my-2 justify-center p-2 h-8 bg-gray-100 rounded-md text-xs shadow-md"

const actionList = ( zoom, actionType, isShowData ) => {
  return [{
    type: "showData",
    icon: <i className={`iconfont ${ isShowData? 'icon-a-huaban2fuben29': 'icon-a-huaban2fuben30'}`}></i>
  }, {
    type: "ai",
    icon: <img src={`${actionType === 'ai'? AiSele: Ai}`} className="w-5" alt="ai" title="ai"/>
  },{
    type: "times",
    icon: <span>{zoom}x</span>
  },{
    type: "setTimes1",
    icon: <span>1X</span>,
    value: 1
  },{
    type: "setTimes4",
    icon: <span>4X</span>,
    value: 4
  },{
    type: "setTimes10",
    icon: <span>10X</span>,
    value: 10
  },{
    type: "setTimes20",
    icon: <span>20X</span>,
    value: 20
  },{
    type: "setTimes40",
    icon: <span>40X</span>,
    value: 40
  },{
    type: "rotate",
    icon: <RefreshIcon></RefreshIcon>
  }, {
    type: "point",
    icon: <i className="iconfont icon-yuan" style={{"fontSize": ".5rem"}}></i>
  }, {
    type: "ellipse",
    icon: <i className="iconfont icon-yuan1" style={{"fontSize": ".5rem"}}></i>
  }, {
    type: "line",
    icon: <i className="iconfont icon-line font-semibold"></i>
  }, {
    type: "rect",
    icon: <i className="iconfont icon-rect" style={{"fontSize": ".5rem"}}></i>
  }, {
    type: "freehand",
    icon: <img src={`${actionType === 'freehand'? DrawFreedrawSele: DrawFreedraw}`} className="w-5" alt="freedraw" title="Freedraw"/>
  },{
    type: "polygon",
    icon: <LightningBoltIcon></LightningBoltIcon>
  }, {
    type: "camera",
    icon: <CameraIcon></CameraIcon>
  }, {
    type: "slideOverview",
    icon: <IdentificationIcon></IdentificationIcon>
  }]
};

const RightBar = () => {

  const { 
    handleClickDraw,
    handleRotationCircle,  // 旋转按钮
    handleScreenShot,      // 截图
    handleSlideOverview,   // 显示隐藏拨片图
    showRightDialog, 
    setMaxZoomLive, 
    zoomLive, 
    showAiDialog,
    isShowData
  } = useContext(viewImgContext);

  const [actionType, setActionType] = useState("");

  const action = (item, index) => {
    setActionType(item.type);
    let actionArr = ["point", "ellipse", "line", "rect", "freehand", "polygon"];
    let setTimes = ["setTimes1", "setTimes4", "setTimes10", "setTimes20", "setTimes40"];

    if(setTimes.includes(item.type)){
      // 设置最大放大倍数
      setMaxZoomLive(item.value);
      return;
    };

    if(item.type === "showData") {
      showRightDialog();
      return
    };

    if(item.type === "ai") {
      showAiDialog()
    }

    // 注册上述的actionArr
    if( actionArr.includes(item.type) ) {
      handleClickDraw && handleClickDraw(item.type);
    }

    // 注册rotationCircle相关
    if( item.type === "rotate" ){
      handleRotationCircle && handleRotationCircle();
    }

    // 注册ScreenShot截图相关
    if( item.type === "camera" ){
      handleScreenShot && handleScreenShot()
    }

    // 注册拨片图相关
    if( item.type === "slideOverview" ){
      handleSlideOverview && handleSlideOverview()
    }
  };

  const list = useMemo(() => {
    return actionList(zoomLive, actionType, isShowData)
  }, [actionType, zoomLive, isShowData]);

  return (
    <div className="w-full h-full bg-gray-100 ">
      {
        list.map((item, index) => (
          <div 
           key={index} 
           className={`${className} ${actionType === item.type ? 'border border-indigo-300 text-blue-400' : 'border'}`} 
           onClick={() => action(item, index)}
          >{item.icon}</div>
        ))
      }
      
    </div>
  )
};

export default RightBar